module.exports = __webpack_public_path__ + "static/media/iutorsay.816f5277.png";